import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Analytics} from '@buncha/config/analytics/analytics';
import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {CustomText} from '@buncha/components/core/text';
import {EventType} from '@buncha/config/analytics/type';
import {Linking} from 'react-native';
import {Modules} from '@buncha/utils/types';
import {Touchable} from '@buncha/components/core/touchable';
import {meijerSupportNumber} from '@buncha/B2B/utils';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  source: 'Order View';
  legacyId: number;
  runId: number;
}

const NeedHelpB2B: React.FC<Props> = ({source, legacyId, runId}) => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};

  const callHandler = useCallback(() => {
    Analytics.eventWithProps('Meijer Support', {
      type: EventType.cta,
      runId,
      orderId: legacyId,
      source,
    });
    Linking.openURL(`tel:+${meijerSupportNumber}`);
  }, [legacyId, runId, source]);

  return (
    <Touchable
      onPress={callHandler}
      style={[styles.container, {borderColor: theme?.background.gray[200]}]}>
      <CustomText
        style={[
          styles.title,
          {
            color: theme?.text.blue[300],
            fontFamily: muliFont[700].normal,
          },
        ]}>
        {title?.needHelp}
      </CustomText>
      <CustomText
        style={[
          styles.description,
          {
            color: theme?.text.gray[100],
            fontFamily: muliFont[600].normal,
          },
        ]}>
        {body?.support}
        <CustomText
          numberOfLines={1}
          ellipsizeMode="tail"
          style={[
            styles.description,
            {
              color: theme?.text.blue[100],
              fontFamily: muliFont[600].normal,
            },
          ]}>
          {`${String(body?.supportNumber)?.toUpperCase()}`}
        </CustomText>
        .
      </CustomText>
    </Touchable>
  );
};

export default React.memo(NeedHelpB2B);
